import React from "react";
import { db } from "../Components/Firebase";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import decimg from "../Pages/mailicon.png"

function oddEven(index) {
    if (index % 2 === 0){
        return "blogli";
    }
    else{
        return "blogli-alt";
    }
}

function BlogViewer() {
    //States for the firestore documents
    const [items, setItems] = React.useState([]);
    const [ids, setIds] = React.useState([]);
    const [current, setCurrent] = React.useState(0);

    React.useEffect(() => {
		const fetchItems = async () => {
			const q = query(collection(db, "Posts"), orderBy("Time", "desc"));
			const querySnapshot = await getDocs(q);
			setItems(querySnapshot.docs.map((doc) => doc.data()));
            setIds(querySnapshot.docs.map((doc) => doc.id));
		};
		fetchItems();
	}, []);

    return (
        <div className="blogviewbox">
            <div className="blog-scroll">
                {items.map((item, index) => (
                    <div className="blogitembox" key={index}>
                            <img src={decimg} className="blogdecorator" alt="decorator"></img>
                        <button onClick={() => setCurrent(index)} className={oddEven(index)}>
                                
                                <div className = "blogdate">{(item.Time) ? item.Time.toDate().toDateString() : "Date Unknown"}:</div>
                                <div className="bloglink">
                                {item.Title}
                                </div>
        
                        </button>
                    </div>
                ))}
            </div>
            <div className="blogpagebox">
                {(items[current]) ?
                    <>
                        <h1 className="blogTitle">{(items[current]) ? JSON.stringify(items[current].Title).replace(/[^\w\s]/gi, '') : ""}</h1>
                        {(items[current].YoutubeLink) ? 
                        <div className="VidBackground">
                            <div className="wrapper-wrapper">
                                <div className="player-wrapper">
                                    <iframe 
                                        className="vid"
                                        src={items[current].YoutubeLink.replace('watch?v=', 'embed/')}
                                        title="YouTube video player"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                        
                        : (null)}
                        
                        {(items[current].Text) ? 
                            <p className="blogP">
                                {(items[current].Text) ? JSON.stringify(items[current].Text).replace(/\\"/g, '"').substring(1, items[current].Text.length+1) : (null)}
                            </p>  
                        : (null)}
                        {!!items[current].T_IMG ? (<img className = "postIMG" src={items[current].T_IMG} alt="post"></img>) : (null)}
                        {(items[current].Body_Text) ? 
                            <p className="blogP">
                                {(items[current].Body_Text) ? JSON.stringify(items[current].Body_Text).replace(/\\"/g, '"').substring(1, items[current].Body_Text.length+1) : (null)}
                            </p>  
                        : (null)}
                        {!!items[current].B_IMG ? (<img className = "postIMG" src={items[current].B_IMG} alt="post"></img>) : (null)}
                        {(items[current].Body2_Text) ? 
                            <p className="blogP">
                                {(items[current].Body2_Text) ? JSON.stringify(items[current].Body2_Text).replace(/\\"/g, '"').substring(1, items[current].Body2_Text.length+1) : (null)}
                            </p>  
                        : (null)}
                         
                        <footer>Posted: {(items[current].Time) ? items[current].Time.toDate().toDateString() : "Date Unknown"}</footer>
                    </>
                : (null)
                }
                
            </div>
        </div>
    )
}

export default BlogViewer;
